import { render } from "./templates/index.html?vue&type=template&id=5be5e461&external"
import script from "./script/index.js?vue&type=script&lang=js&external"
export * from "./script/index.js?vue&type=script&lang=js&external"

import "./index.vue?vue&type=style&index=0&id=5be5e461&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__